
export default function ACCESS_TOKEN() {
    const TOKEN = localStorage.getItem("accessToken");

    console.log(TOKEN,'TOKEN')
    console.log(localStorage.getItem("accessToken"),'TOKEN')
    if(TOKEN !== null){
      return `Bearer ${TOKEN}`
    }else{
      return null
    }
  }

// const ACCESS_TOKEN = localStorage.getItem("accessToken");

// const accessToken = `Bearer ${ACCESS_TOKEN}`;
// export default accessToken;
